import Constant from '@/const';
import axios from 'axios';

const getMjknReporting = async params => {
  try {
    const response = await axios.get(Constant.apiUrl.concat('/report/mjkn'), {
      params,
    });
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getMjknReporting;
